import { useQuery } from '@tanstack/react-query';
import type { OrganizerFollowStatusResponse } from '@/types/organizer-follow';
import { withBasePath } from '@/utils/withBasePath';

export function useOrganizerFollowStatus(organizerId: string) {
  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['organizer-follow-status', organizerId],
    queryFn: () => fetchOrganizerFollowStatus(organizerId),
    enabled: Boolean(organizerId),
    retry: false,
  });

  return {
    authenticated: data?.authenticated ?? false,
    followedByYou: data?.followedByYou ?? false,
    numFollowers: typeof data?.numFollowers === 'number' ? data.numFollowers : undefined,
    userId: data?.userId,
    statusLoading: Boolean(organizerId) && (isLoading || isFetching),
  };
}

async function fetchOrganizerFollowStatus(
  organizerId: string,
): Promise<OrganizerFollowStatusResponse> {
  const res = await fetch(withBasePath(`/api/organizers/${organizerId}/follow-status/`), {
    credentials: 'include',
  });
  if (!res.ok) {
    return { authenticated: false, followedByYou: false };
  }
  try {
    return (await res.json()) as OrganizerFollowStatusResponse;
  } catch {
    return { authenticated: false, followedByYou: false };
  }
}
